import { t } from "./localization";

import settings from "../settings";
import filter from "lodash/filter";

const encyclopedia = window.__PRELOADED_STATE__ && window.__PRELOADED_STATE__.encyclopedia || {};

const getNationData = function (nationName) {
  return encyclopedia.nations[nationName] || null;
};

const getShipTypeData = function (shipType) {
  return encyclopedia.vehiclesTypes[shipType] || null;
};

export const getLocalizationNationName = function (nationName) {
  const nationData = getNationData(nationName);

  return nationData && nationData.mark || '';
};

export const getNationUrl = function (nationName, size) {
  const nationData = getNationData(nationName);
  let iconUrl = '';

  if (nationData) {
    iconUrl = !size ? `${settings.mediaPath}${nationData.icons.default}` : `${settings.mediaPath}${nationData.icons[size]}`;
  }
  return iconUrl;
};

export const getLocalizationShipTypeName = function (shipType) {
  const shipTypeData = getShipTypeData(shipType);

  return shipTypeData && shipTypeData.mark || '';
};

export const getShipTypeUrl = function (shipType, isPremium, isSpecial) {
  const shipTypeData = getShipTypeData(shipType);
  if (!shipTypeData) return '';

  const iconUrls = shipTypeData.icons;
  const mediaPath = settings.mediaPath;
  let icon = iconUrls.default;

  if (isPremium) icon = iconUrls.premium;

  if (isSpecial) icon = iconUrls.special;

  return `${mediaPath}${icon}`;
};

let nationShipsGlossMap = {};
if (encyclopedia.nations) {
  for (const key in encyclopedia.nations) {
    const nation = encyclopedia.nations[key];
    nationShipsGlossMap[key] = {
      name: nation.mark
    };
  }
}

if (encyclopedia.vehiclesTypes) {
  for (const key in encyclopedia.vehiclesTypes) {
    const vehiclesType = encyclopedia.vehiclesTypes[key];
    for (const k in nationShipsGlossMap) {
      nationShipsGlossMap[k] = {
        ...nationShipsGlossMap[k],
        [key]: `${vehiclesType.mark}`
      };
    }
  }
}

export const NATIONS_SHIPS_TEXTS_MAP = nationShipsGlossMap;